const defaultAddress = {
  street: '',
  city: '',
  postalCode: '',
};

export default {
  natural: {
    kind: 'natural',
    firstName: '',
    lastName: '',
    birthdate: '',
    gender: 'M',
    nationality: 'FR',
    withJustice: false,
    address: defaultAddress,
    email: '',
    phoneNumber: '',
    idFile: null,
  },

  legal: {
    kind: 'legal',
    legalName: '',
    siren: '',
    rcs: '',
    withJustice: false,
    address: defaultAddress,
    email: '',
    phoneNumber: '',
    kbisFile: null,
  },
};



/** WEBPACK FOOTER **
 ** ./client/act/person.js
 **/